import Heading from '../Typography/Heading';
import Paragraph from '../Typography/Paragraph';
import Shape from '../../../../images/shape/header.svg';
var Hero = function (_a) {
    var title = _a.title, headline = _a.headline;
    return (<div className="p-default dark relative bg-brand-01">
      <div className="container">
        <div className="flex flex-col items-center gap-4">
          <Paragraph size="headline" center>
            {headline}
          </Paragraph>
          <Heading level={1} type="h2" center>
            {title}
          </Heading>
        </div>
      </div>
      <div className="absolute -bottom-20 -right-60 z-90 hidden md:block">
        <img className="relative left-0 right-0 block h-[400px] w-[400px]" src={Shape} alt="Forme"/>
      </div>
    </div>);
};
export default Hero;
